import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import LogoLoader from 'components/Loader/LogoLoader';
import APIErrorMascot from 'components/Mascot/APIErrorMascot';
import { initialEmployeeFormData } from 'containers/Employees/shared/EmployeeForm/EmployeeFormTabs/schema';
import { transformEmployeeDataToFormdata } from 'containers/Employees/shared/transformEmployeeDataToFormData';
import { useFetchEmployeeById } from 'hooks/employee/useFetchEmployeeById';

import EmployeeFormTabs from '../shared/EmployeeForm/EmployeeFormTabs';

const EditEmployee: React.FC<unknown> = () => {
  const [formData, setFormData] = useState<typeof initialEmployeeFormData>(initialEmployeeFormData);

  const { id } = useParams();

  const { data, status } = useFetchEmployeeById(id!);

  useEffect(() => {
    if (status === 'success') {
      const fetchedFormData = data?.payload;
      const formData = transformEmployeeDataToFormdata(fetchedFormData);

      setFormData(formData);
    }
  }, [status, data]);

  if (status === 'loading') return <LogoLoader />;
  if (status === 'error') return <APIErrorMascot />;

  return <EmployeeFormTabs formData={formData} />;
};

export default EditEmployee;
